import { render, staticRenderFns } from "./SystemInfoDetailBtn.vue?vue&type=template&id=12d42ede"
import script from "./SystemInfoDetailBtn.vue?vue&type=script&lang=js"
export * from "./SystemInfoDetailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports